import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import { sendEmail } from "../helpers/sendEmail";

// Directus config for sending to user's own email
const personalDirectusSendInfo = {
  provider: "directus",
  apiUrl: process.env.REACT_APP_DIRECTUS_PERSONAL_MAIL_URL || "/mail/send",
  token: process.env.REACT_APP_DIRECTUS_PERSONAL_TOKEN,
  from: process.env.REACT_APP_DIRECTUS_PERSONAL_FROM,
  subjectPrefix: process.env.REACT_APP_DIRECTUS_PERSONAL_SUBJECT_PREFIX || "HR Tests",
};

const FinishPage = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const location = useLocation();
  const blob = location.state?.blob;
  const fileName = location.state?.fileName;
  const score = location.state?.score;

  const handleDownload = () => {
    if (!blob || !fileName) return;

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleSubmit = async () => {
    if (!email.trim()) {
      setMessage("Введите корректный email.");
      return;
    }
    if (!blob || !fileName) return;

    const { fio, test, pdfUrl, result } = location.state;

    try {
      // Flow для отправки email (не для сохранения в БД!)
      // Этот Flow должен просто отправлять письмо с результатами
      const emailFlowId = '310210af-ae3d-41e9-b7cc-00fdfa0f6c60'

      const directusSendInfo = {
        provider: "directus_flow",
        baseUrl: "https://crm-hr.kzn.ru",
        flowId: emailFlowId,
        token: "sGaLAYCUxT_HpfAaMiQNb4qzieuAtUAM",
        subjectPrefix: process.env.REACT_APP_DIRECTUS_SUBJECT_PREFIX || "HR Tests",
      };

      await sendEmail(
        email,
        test,
        fio,
        result,
        pdfUrl,
        directusSendInfo,
      );
      setMessage("Результат отправлен на почту!");
    } catch (err) {
      console.error(err);
      setMessage("Ошибка при отправке письма.");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300 flex flex-col items-center">
      <Navbar />

      <div className="mt-20 bg-white rounded-xl shadow-lg p-8 max-w-md w-full text-center">
        <p className="text-2xl font-semibold text-gray-800 mb-6">
          Результат успешно отправлен
        </p>

        {blob && score ? (
          <>
            <input
              type="email"
              placeholder="Введите email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-gray-300 text-[16px] rounded-md p-2 mb-4"
            />

            <div className="flex flex-col gap-3 justify-between text-sm">
              <button
                onClick={handleSubmit}
                className="bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-6 rounded-lg transition duration-200"
              >
                Отправить на email
              </button>
              <button
                onClick={handleDownload}
                className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-lg transition duration-200 "
              >
                Скачать результат
              </button>
            </div>
          </>
        ) : (
          blob && (
            <button
              onClick={handleDownload}
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-lg transition duration-200 "
            >
              Скачать результат
            </button>
          )
        )}
        {message && (
          <p className="mt-4 text-sm text-gray-700 font-medium">{message}</p>
        )}
      </div>
    </div>
  );
};

export default FinishPage;